import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Button, Upload, message } from 'antd';
import actions from '@/redux/action';
import Utils from '@/utils';
import { ReactComponent as FileIcon } from '@/assets/icons/file.svg';
import AudioCompressWork from './children/AudioCompressWork';
import sentGAEvent from '@/ga';
import '@/assets/audioCompress.less';

class AudioCompress extends Component {
  constructor(props) {
    super(props);
    this.state = {
      audioAccept: '.wav,.mp3,.m4a,.aac,.ogg,.mp4,.mov,.webm',
      stopUpload: false,
    };
    this.stopUpload = false;
  }

  uploadProps = {
    accept: '.wav,.mp3,.m4a,.aac,.ogg,.mp4,.mov,.webm',
    maxCount: 5,
    multiple: true,
    showUploadList: false,
    beforeUpload: (file, fileList) => {
      if (this.stopUpload) {
        if (file.uid === fileList[fileList.length - 1].uid) {
          this.stopUpload = false;
        }
        return Upload.LIST_IGNORE;
      }
      this.stopUpload = true;
      if (
        fileList.length > 5 ||
        this.props.audioCompressList.length + fileList.length > 5
      ) {
        message.warn(
          this.props.t('common:Support merging audio files at most', { num: 5 })
        );
      }
      let audioItemSizes = '';
      const audioCompressList = [...this.props.audioCompressList];
      fileList.forEach((item, index) => {
        // if (item.size >= 20 * 1024 * 1024) {
        //   // message.warn(this.props.t("common:Max file size for videos is 20 MB. Get HitPaw Toolkit for big file."));
        //   if (Utils.isNeedToShowPurchaseModal()) {
        //     this.props.onPurchaseModalObjChange({
        //       visible: true,
        //       type: "uploadSizeBiggerThanLimit",
        //     });
        //     return false;
        //   }
        // } else
        if (!Utils.validate(item, '.wav,.mp3,.m4a,.aac,.ogg,.mp4,.mov,.webm')) {
          message.warn(`The file ${item.name} format is not supported!`);
        } else if (audioCompressList.length < 5) {
          if (item.size >= 20 * 1024 * 1024) {
            if (Utils.isNeedToShowPurchaseModal()) {
              this.props.onPurchaseModalObjChange({
                visible: true,
                type: 'uploadSizeBiggerThanLimit',
                trigger: 'SizeExceed20M',
              });
              let action = Utils.gaUpgradePromptShow(this.props.work);

              if (action) {
                sentGAEvent({
                  category: 'UpgradePrompShow',
                  action: action,
                  label: 'Null',
                });
              }
              return false;
            }
          }
          sentGAEvent({
            category: 'audio_compress_add_files',
            action: 'audio_compress_add_files',
            label:
              /\.[^.]+$/.exec(file.name)[0].toLocaleLowerCase() +
              '_' +
              (file.size / 1024).toFixed(2) +
              'kb',
          });
          const newFile = {
            name: item.name,
            guid: new Date().getTime() + index,
            size: item.size,
            status: 'ready',
            uploadStatus: false,
            fileObj: item,
            type: item.type,
          };
          audioCompressList.push(newFile);
          audioItemSizes =
            audioItemSizes + '_' + (file.size / 1024).toFixed(2) + 'kb';
        }
      });
      this.props.onAudioCompressListChange(audioCompressList);
      return Upload.LIST_IGNORE;
    },
  };

  handleStopUpload = (label) => {
    sentGAEvent({
      category: 'audio_compress_add_files',
      action: 'audio_compress_add_files_click',
      label,
    });
    this.stopUpload = false;
  };
  render() {
    const { t } = this.props;
    return (
      <div className='AudioCompress'>
        <div className='audio-work-hd'>
          <h1 className='container'>{t('HitPaw Online Audio Compressor')}</h1>
          <p className='container'>
            {t('Reduce audio file size online without quality loss.')}
          </p>
          {!this.props.audioCompressList.length ? (
            <Upload {...this.uploadProps} maxCount={5}>
              <Button
                size='large'
                icon={<FileIcon />}
                onClick={() => this.handleStopUpload('choose_file')}
              >
                {t('upload:Choose File')}
              </Button>
            </Upload>
          ) : null}
        </div>
        {this.props.audioCompressList.length ? (
          <AudioCompressWork
            uploadProps={this.uploadProps}
            handleStopUpload={this.handleStopUpload}
          />
        ) : null}
      </div>
    );
  }
}

const mapStateToPropos = (state) => ({
  audioCompressList: state.work.audioCompressList,
  work: state.work.work,
});

const mapDispatchToProps = (dispatch) => ({
  onAudioCompressListChange: (work) =>
    dispatch(actions.onAudioCompressListChange(work)),
  onPurchaseModalObjChange: (purchaseModalObj) =>
    dispatch(actions.onPurchaseModalObjChange(purchaseModalObj)),
});

export default connect(
  mapStateToPropos,
  mapDispatchToProps
)(withTranslation(['audioCompress', 'upload', 'common'])(AudioCompress));
